import { render, staticRenderFns } from "./OfficeInfo.vue?vue&type=template&id=45e973ee&scoped=true&"
import script from "./OfficeInfo.vue?vue&type=script&lang=js&"
export * from "./OfficeInfo.vue?vue&type=script&lang=js&"
import style0 from "./OfficeInfo.vue?vue&type=style&index=0&id=45e973ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e973ee",
  null
  
)

export default component.exports